import React, { useEffect, useState } from 'react'
import {
  Button,
  Form,
  Modal,
  Checkbox,
  FormField,
  Icon,
  Dropdown,
} from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { RefreshUserFacilitiesList } from '../../../../redux/actions/facility'
import styles from './facility-modal.module.css'
import StatusDialog from '../../../status-dialog'
import IntelMsg from '../../../ItelMsg/index'
import { GetUserCustomers } from '../../../../services/customer/index'
import {
  GetSFDFacilityTemplate,
  saveFacility,
} from '../../../../services/facility/index'
import ValidatorGenerator from '../../../../services/configuration-template/validatores'

let tenantId = ''
let product = ''
const AddFacility = ({ show, setShow }) => {
  const [disableSubmit, setDisableSubmit] = useState(true)
  const [customerFlag, setCustomerFlag] = useState(false)
  const [showStatusDialog, setShowStatusDialog] = useState(false)
  const [dialogContent, setDialogContent] = useState(<></>)
  const [creationData, setCreationData] = useState([])

  const [selectedFacility, setSelectedFacility] = useState('')
  const [selectedCustomer, setSelectedCustomer] = useState('')
  const [customerEmpty, setCustomerEmpty] = useState(true)
  const [selectedCustomerTitle, setSelectedCustomerTitle] = useState('')
  const [xIsEmpty, setXIsEmpty] = useState(false)
  const [yIsEmpty, setYIsEmpty] = useState(false)
  const { register, errors, handleSubmit, setValue, clearErrors } = useForm()
  const { t } = useTranslation()
  const facilityTypes = [
    { value: 'SFDA', text: 'SFDA Facility' },
    { value: 'DEFAULT', text: 'Facility' },
  ]
  const [pointsShape, setPoints] = useState('')
  const [customers, setCustomers] = useState([])

  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  if (userEmail) {
    const products = JSON.parse(localStorage.getItem('products'))
    product = localStorage.getItem('product')
    // eslint-disable-next-line prefer-destructuring
    tenantId = products.filter((p) => p.productName === product)[0]
  }
  const handleClose = () => {
    setShow(false)
    setCustomerFlag(false)
    setCreationData([])
    setDisableSubmit(true)
  }
  useEffect(() => {
    if (setSelectedCustomer) {
      const customer = customers.filter((c) => c.value === selectedCustomer)
      setSelectedCustomerTitle(customer.text)
    }
  }, [selectedCustomer])
  useEffect(() => {
    GetUserCustomers(userEmail, product).then((result) => {
      console.log('customeers', result)
      if (result) {
        const list = []
        result.forEach((element) => {
          console.log('selectedFacility', selectedFacility)
          if (selectedFacility === 'SFDA') {
            if (element.type === 'SFDA_COMPANY') {
              list.push({
                value: element.tbCustomerId,
                text: element.title,
              })
            }
          } else if (selectedFacility === 'DEFAULT') {
            if (element.type === 'DEFAULT') {
              list.push({
                value: element.tbCustomerId,
                text: element.title,
              })
            }
          }
        })
        setCustomers(list)
      }
    })
  }, [selectedFacility])
  const dispatch = useDispatch()
  const createTextField = (columnData) => {
    const validate = ValidatorGenerator(columnData['validator type'])
    return (
      <Form.Field error={errors[columnData['input name']]}>
        <strong>
          <IntelMsg id={columnData['label ID']} />
        </strong>
        <input
          ref={(ref) => {
            register(ref, { validate })
          }}
          type={columnData['input type'] === 'NUMERIC' ? 'number' : 'text'}
          step="0.00000000001"
          name={columnData['input name']}
          placeholder={t(columnData.placeholder)}
        />
        {columnData['validator type'] !== 'noValidation' ? (
          <small style={{ color: 'red' }}>
            {errors[columnData['input name']] ? (
              <IntelMsg id={columnData['err msg']} />
            ) : (
              '**'
            )}
          </small>
        ) : null}
      </Form.Field>
    )
  }
  function createCheckBox(columnData) {
    register({ name: columnData['input name'], value: false })

    return (
      <Form.Field>
        <Checkbox
          label={t(columnData['header name'] || columnData['input name'])}
          name={columnData['input name']}
          onChange={(e, { name, checked }) => {
            setValue(name, checked)
          }}
        />
      </Form.Field>
    )
  }
  function createDatePicker(columnData) {
    const validate = ValidatorGenerator(columnData['validator type'])
    console.log('validator type', columnData['validator type'])
    return (
      <Form.Field error={errors[columnData['input name']]}>
        <strong>
          <IntelMsg id={columnData['label ID']} />
        </strong>
        <input
          ref={(ref) => {
            register(ref, { validate })
          }}
          type="date"
          name="date"
          placeholder={t(columnData.placeholder)}
        />
        {columnData['validator type'] !== 'noValidation' ? (
          <small style={{ color: 'red' }}>
            {errors[columnData['input name']] ? (
              <IntelMsg id={columnData['err msg']} />
            ) : (
              '**'
            )}
          </small>
        ) : null}
      </Form.Field>
    )
  }
  function createSelectField(columnData) {
    let options = []
    if (columnData['input name id'] === 'groupId') {
      return <option>dgdg</option>
    }

    if (columnData['input name id'] === 'countryName') options = []
    return (
      <Form.Field error={errors[columnData['input name']]}>
        <strong>
          <IntelMsg id={columnData['label ID']} />
        </strong>
        <select
          ref={register({
            validate: { isValidSelect: (value) => value !== '-1' },
          })}
          name={columnData['input name']}
        >
          <option value={-1}>{t(columnData.placeholder)}</option>
          {options}
        </select>
        {columnData['validator type'] !== 'noValidation' ? (
          <small style={{ color: 'red' }}>
            {errors[columnData['input name']] ? (
              <IntelMsg id={columnData['err msg']} />
            ) : (
              '**'
            )}
          </small>
        ) : null}
      </Form.Field>
    )
  }

  function createTextArea(columnData) {
    const validate = ValidatorGenerator(columnData['validator type'])
    return (
      <Form.Field>
        <strong>
          <IntelMsg id={columnData['label ID']} />
        </strong>
        <textarea
          ref={register({ validate })}
          name={columnData['input name']}
          rows={3}
        />
        {columnData['validator type'] !== 'noValidation' ? (
          <small style={{ color: 'red' }}>
            {errors[columnData['input name']] ? (
              <IntelMsg id={columnData['err msg']} />
            ) : (
              '**'
            )}
          </small>
        ) : null}
      </Form.Field>
    )
  }
  const sorting = (config1, config2) => {
    if (config1.sort < config2.sort) {
      return -1
    }
    if (config1.sort > config2.sort) {
      return 1
    }
    // a must be equal to b
    return 0
  }
  function createColumn(columnData) {
    console.log('input type', columnData['input type'])
    if (columnData['input type'] === 'STRING')
      return createTextField(columnData)
    if (columnData['input type'] === 'SELECT')
      return createSelectField(columnData)
    if (columnData['input type'] === 'TEXT_AREA')
      return createTextArea(columnData)
    if (columnData['input type'] === 'BOOLEAN') {
      return createCheckBox(columnData)
    }
    if (
      columnData['input type'] === 'HIJRI' ||
      columnData['input type'] === 'DATE'
    ) {
      return createDatePicker(columnData)
    }
    return createTextField(columnData)
  }
  const getDialogContent = (success, msg) => {
    if (success) {
      return (
        <>
          <Icon name="check" size="huge" color="green" />
          <div style={{ fontSize: 'x-large' }}>{msg}</div>
        </>
      )
    }
    return (
      <>
        <Icon name="exclamation triangle" size="huge" color="red" />
        <div style={{ fontSize: 'x-large' }}>{msg}</div>
      </>
    )
  }

  const coordinates = []
  let points = ''
  async function onSubmitXY(data) {
    clearErrors()
    console.log(data)
    if (data.x === '') {
      setXIsEmpty(true)
    }
    if (data.y === '') {
      setYIsEmpty(true)
    }
    if (xIsEmpty && yIsEmpty) {
      console.log('coordinates', coordinates)
    } else {
      console.log('points', points)
      coordinates.push({ x: data.x, y: data.y })
      const shape = coordinates.map(function (item) {
        points += `${item.x},${item.y}`
        return points
      })

      setPoints(shape.concat(shape))
      console.log('coordinates', coordinates)
    }
  }
  async function onSubmit(data) {
    console.log('selectedCustomer', selectedCustomer)
    if (selectedFacility === 'SFDA') {
      if (customerEmpty || xIsEmpty || yIsEmpty) {
        // setCustomerEmpty(true)
        setDialogContent(getDialogContent(false, 'Please fill missing values'))
        setShowStatusDialog(true)
      } else {
        clearErrors()
        const finalData = data
        try {
          const response = await saveFacility(
            product,
            userEmail,
            finalData,
            selectedFacility,
            selectedCustomer,
            selectedCustomerTitle,
            tenantId.tenantId,
            coordinates,
          )
          let content = <></>
          if (response.success) {
            // setRefresh(true)
            content = getDialogContent(
              true,
              response.message ? response.message : 'Facility Added',
            )
            setDialogContent(content)
            setShowStatusDialog(true)
            setShow(false)
            dispatch(RefreshUserFacilitiesList(true))
          } else {
            // setRefresh(true)
            let { msg } = response
            msg = Array.isArray(msg)
              ? msg.map((error) => <div>{error}</div>)
              : msg
            content = getDialogContent(false, msg || 'Facility Added')
            setDialogContent(content)
            setShowStatusDialog(true)
            dispatch(RefreshUserFacilitiesList(true))
          }
        } catch (e) {
          let { msg } = e
          msg = Array.isArray(msg)
            ? msg.map((error) => (
                <>
                  <div>{error}</div>
                  <br />
                </>
              ))
            : msg
          setDialogContent(getDialogContent(false, msg || 'Facility Not Added'))
          setShowStatusDialog(true)
          setShow(false)
        }
      }
    } else if (selectedFacility === 'DEFAULT') {
      console.log('selectedFacility', selectedFacility)
      if (customerEmpty) {
        // setCustomerEmpty(true)
        setDialogContent(getDialogContent(false, 'Please Choose Customer'))
        setShowStatusDialog(true)
      } else {
        clearErrors()
        const finalData = data
        try {
          const response = await saveFacility(
            product,
            userEmail,
            finalData,
            selectedFacility,
            selectedCustomer,
            selectedCustomerTitle,
            tenantId.tenantId,
            coordinates,
          )
          let content = <></>
          if (response.success) {
            // setRefresh(true)
            content = getDialogContent(
              true,
              response.message ? response.message : 'Facility Added',
            )
            setDialogContent(content)
            setShowStatusDialog(true)
            setShow(false)
            dispatch(RefreshUserFacilitiesList(true))
          } else {
            // setRefresh(true)
            let { msg } = response
            msg = Array.isArray(msg)
              ? msg.map((error) => <div>{error}</div>)
              : msg
            content = getDialogContent(false, msg || 'Facility Added')
            setDialogContent(content)
            setShowStatusDialog(true)
            dispatch(RefreshUserFacilitiesList(true))
          }
        } catch (e) {
          let { msg } = e
          msg = Array.isArray(msg)
            ? msg.map((error) => (
                <>
                  <div>{error}</div>
                  <br />
                </>
              ))
            : msg
          setDialogContent(getDialogContent(false, msg || 'Facility Not Added'))
          setShowStatusDialog(true)
          setShow(false)
        }
      }
    }
  }
  const validateXY = ValidatorGenerator('isRequired')
  return (
    <>
      <div>
        <Modal
          onClose={() => setShow(false)}
          onOpen={() => setShow(true)}
          open={show}
          centered
          style={{ position: 'relative', height: 'auto' }}
        >
          <Modal.Header className={styles.header} closeButton>
            <IntelMsg id="addFacilityHeaderModal" />
          </Modal.Header>
          <Modal.Content scrolling style={{ height: '70%' }}>
            <Form
              id="facilityAddForm"
              onSubmit={handleSubmit(onSubmit)}
              widths="equal"
            >
              <FormField error={errors.facilityTypes}>
                <strong>
                  <IntelMsg id="facilityType" />
                </strong>
                <Dropdown
                  onFocus={() => {}}
                  name="facilityType"
                  className="my-className"
                  options={facilityTypes}
                  placeholder="Select Facility"
                  fluid
                  search
                  selection
                  onChange={async (e, data) => {
                    console.log('e.target.value', data.value)
                    setDisableSubmit(false)
                    setSelectedFacility(data.value)
                    setCustomerFlag(true)

                    GetSFDFacilityTemplate(data.value, product).then(
                      (configData) => {
                        if (configData['attributes map']) {
                          const creationMap = JSON.parse(
                            configData['attributes map'],
                          )
                          creationMap.sort(sorting)
                          setCreationData([])
                          setCreationData(creationMap)
                        }
                      },
                    )
                  }}
                ></Dropdown>
              </FormField>
              {customerFlag ? (
                <FormField error={errors[['customers']]}>
                  <strong>
                    <IntelMsg id="Customers" />
                  </strong>
                  <Dropdown
                    name="customerNames"
                    className="my-className"
                    options={customers}
                    placeholder="You have to select Customer"
                    fluid
                    search
                    selection
                    defaultValue=""
                    error={customerEmpty}
                    onChange={async (e, data) => {
                      setDisableSubmit(false)
                      setCustomerEmpty(false)
                      console.log('e.target.value', data.value)
                      setSelectedCustomer(data.value)
                      const customer = customers.filter(
                        (c) => c.value === selectedCustomer,
                      )
                      setSelectedCustomerTitle(customer.text)
                    }}
                  />

                  <small style={{ color: 'red' }}>
                    <IntelMsg id={['**']} />
                  </small>
                </FormField>
              ) : null}

              {creationData.map((rowData) => (
                <Form.Group>
                  {rowData.data.map((columnData) => createColumn(columnData))}
                </Form.Group>
              ))}
            </Form>
            {customerFlag && selectedFacility === 'SFDA' ? (
              <Form
                id="addXY"
                onSubmit={handleSubmit(onSubmitXY)}
                widths="equal"
                style={{ position: 'relative', paddingTop: '10px' }}
              >
                <Form.Group>
                  <Form.Field>
                    <strong>
                      <IntelMsg id="landCoordinatesLabel" />
                    </strong>
                  </Form.Field>
                </Form.Group>

                <Form.Group widths="equal">
                  <Form.Field error={errors[['x']]} required>
                    <strong>
                      <IntelMsg id="X Coordinate" />
                    </strong>
                    <input
                      ref={(ref) => {
                        register(ref, { validateXY })
                      }}
                      type="number"
                      step="0.00000000001"
                      min="1"
                      name="x"
                      placeholder={t('X')}
                      onChange={() => {
                        setXIsEmpty(false)
                      }}
                    />
                    {xIsEmpty ? (
                      <small style={{ color: 'red' }}>
                        <IntelMsg id={['required!']} />
                      </small>
                    ) : (
                      <small style={{ color: 'red' }}>
                        <IntelMsg id={['**']} />
                      </small>
                    )}
                  </Form.Field>
                  <Form.Field error={errors[['y']]} required>
                    <strong>
                      <IntelMsg id="Y Coordinate" />
                    </strong>
                    <input
                      ref={(ref) => {
                        register(ref, { validateXY })
                      }}
                      type="number"
                      step="0.00000000001"
                      name="y"
                      min="1"
                      placeholder={t('Y')}
                      onChange={() => {
                        setYIsEmpty(false)
                      }}
                    />
                    {yIsEmpty ? (
                      <small style={{ color: 'red' }}>
                        <IntelMsg id={['required!']} />
                      </small>
                    ) : (
                      <small style={{ color: 'red' }}>
                        <IntelMsg id={['**']} />
                      </small>
                    )}
                  </Form.Field>
                  <Button
                    type="submit"
                    form="addXY"
                    style={{
                      fontSize: '12px',
                      marginTop: '18px',
                      marginBottom: '20px',
                    }}
                  >
                    Add Point
                  </Button>
                </Form.Group>
                <strong>
                  <IntelMsg id={pointsShape} />
                </strong>
              </Form>
            ) : null}
          </Modal.Content>
          <Modal.Actions>
            <Button
              type="submit"
              disabled={disableSubmit}
              form="facilityAddForm"
              className={styles.positiveStatus}
            >
              <IntelMsg id="loginSubmitButton" />
            </Button>
            <Button
              className={styles.negativeStatus}
              onClick={() => {
                handleClose()
              }}
            >
              <IntelMsg id="closeBtn" />
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
      <StatusDialog
        showDialog={showStatusDialog}
        setShowDialog={setShowStatusDialog}
        dialogHeader={<IntelMsg id="Facility" />}
        dialogContent={dialogContent}
      />
    </>
  )
}
AddFacility.propTypes = {
  setShow: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}
export default AddFacility
